import React from 'react'
import { Menu, MenuItem } from '@mui/material'
import { CarePlanActions } from './carePlanActions'
import { SURVEYS_ROW_KEY } from './carePlanState'

type PickerOption = { label: string; trackKey?: string }

export type PickerState = {
  rowKey: string
  month: number
  options: PickerOption[]
  defaultMonths: number
  anchorEl: HTMLElement
}

type Props = {
  picker: PickerState | null
  actions: CarePlanActions
  onClose: () => void
}

const ItemPicker = ({ picker, actions, onClose }: Props) => {
  const pick = ({ label, trackKey }: PickerOption) => {
    if (picker) {
      if (picker.rowKey === SURVEYS_ROW_KEY) {
        actions.prescribeSurvey(picker.month, label)
      } else {
        actions.placeItem(picker.rowKey, picker.month, label, picker.defaultMonths, trackKey)
      }
    }
    onClose()
  }

  return (
    <Menu anchorEl={picker?.anchorEl} open={!!picker} onClose={onClose}>
      {(picker?.options ?? []).map((option) => (
        <MenuItem key={option.trackKey ?? option.label} onClick={() => pick(option)}>
          {option.label}
        </MenuItem>
      ))}
    </Menu>
  )
}

export default ItemPicker
